<template>
  <div class="or-hr-container">
    <div></div>
    <p>OR</p>
    <div></div>
  </div>
</template>
<script>
  export default {
    name: 'OrHr',
  };
</script>

<style scoped lang="scss">
  .or-hr-container {
    display: flex;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: -0.015em;
      text-align: center;
      margin: 0;
      margin-left: 6px;
      margin-right: 6px;
    }

    div {
      background-color: #000000;
      height: 1px;
      flex: 1;
    }
  }
</style>
